import axios, { AxiosInstance, AxiosPromise } from 'axios'
import { axiosInstance } from '@yuanfudao/metis-standard-data'
import { MetisDialog, MetisMessage } from '@yuanfudao/metis-web-component'
import pubConfig from '@/config'
import qs from 'qs'
import {
  codeRefreshTokenExpired,
  CostomAxiosRequestConfig,
  ERROR_CODE,
  getAccessToken,
  // loginEmitter,
  requestInterceptor,
  responseFulfilledInterceptor,
  responseInterceptor,
} from '@yuanfudao/metis-unified-login'
import { API_CODE } from '@/constants/http'

let modalBlock = false

const goToHome = (replace?: boolean) => {
  const { href } = window.location
  const [base] = href.split('#')
  const target = `${base}#/home`
  if (replace) {
    window.location.replace(target)
  } else {
    window.location.href = target
  }
}

const instance: AxiosInstance = axios.create({
  baseURL: '', // 因为接口地址跨域原因，此处baseURl不设置，在instance.interceptors.request有对baseUrl处理
  timeout: 500000,
  headers: {
    'Content-Type': 'application/json', // application/x-www-form-urlencoded
  },
  withCredentials: true,
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  },
})

const checkLoginUrls: string[] = [
  '/home',
  '/school-info-edit',
  '/school-info-detail',
  '/lesson-choose',
  '/teacher-info',
  '/class-info',
  '/student-info',
  '/schedule',
  '/teach',
  '/my-choose',
  '/lesson-detail',
]

axiosInstance.interceptors.request.use(
  requestInterceptor({
    when(config) {
      return checkLoginUrls.findIndex((c) => window.location.hash.includes(c)) > -1 || !codeRefreshTokenExpired()
    },
    setConfig(config) {
      config.baseURL = pubConfig.HTTP_BASE_URL + config.baseURL
      return {
        ...config,
        params: {
          ...config.params,
          ...pubConfig.requestParams,
        },
      }
    },
  }),
  (err) => Promise.reject(err),
)

axiosInstance.interceptors.response.use(
  responseFulfilledInterceptor(),
  responseInterceptor({
    whenUnauthorized: (err) => {
    },
    whenForbidden: (err) => {
      if (err?.response?.config?.url?.includes('/verifier/api/sms')) {
        err.response.data.code = ERROR_CODE.REFRESH_OVER_FREQ
        return Promise.reject(err)
      }
      if ([ERROR_CODE.NO_PERMISSION, ERROR_CODE.NO_PERMISSION2].includes(err?.response?.data?.code)) {
        // if (err?.response?.config?.params?.mute) {
        return Promise.reject(err)
        // }
        // loginEmitter.emit('goNoPermission') // 目前暂无 403 页
      }
      return Promise.reject(err)
    },
  }),
)

// 拦截器的执行顺序是后 use 的先执行，所以把统一的拦截放在最后use
instance.interceptors.request.use(
  requestInterceptor({
    when(config) {
      return checkLoginUrls.findIndex((c) => window.location.hash.includes(c)) > -1 || !codeRefreshTokenExpired()
    },
    setConfig(config) {
      config.baseURL = pubConfig.HTTP_BASE_URL + config.baseURL
      return {
        ...config,
        params: {
          ...config.params,
          ...pubConfig.requestParams,
        },
      }
    },
  }),
  (err) => Promise.reject(err),
)

// 响应拦截器的执行顺序是先 use 的先执行，所以把统一的拦截放在最前面
instance.interceptors.response.use(
  responseFulfilledInterceptor(),
  responseInterceptor({
    whenUnauthorized: (err) => {
    },
    whenForbidden: (err) => {
      if (err?.response?.config?.url?.includes('/verifier/api/sms')) {
        err.response.data.code = ERROR_CODE.REFRESH_OVER_FREQ
        return Promise.reject(err)
      }
      if ([ERROR_CODE.NO_PERMISSION, ERROR_CODE.NO_PERMISSION2].includes(err?.response?.data?.code)) {
        // if (err?.response?.config?.params?.mute) {
        return Promise.reject(err)
        // }
        // loginEmitter.emit('goNoPermission') // 目前暂无 403 页
      }
      return Promise.reject(err)
    },
  }),
)

instance.interceptors.response.use(
  (res) => {
    if ([
      API_CODE.TenantNotMatch,
      API_CODE.CollectionNotFound,
      API_CODE.ModuleNotFound,
      API_CODE.CollectionFinished,
      API_CODE.CollectionAbandon,
    ].includes(res?.data?.code)) {
      if (!modalBlock) {
        modalBlock = true
        MetisDialog.warning({
          title: '无法操作',
          content: res?.data?.message,
          okText: '我知道了',
          onOk: () => {
            modalBlock = false
            goToHome(true)
          },
          cancelButtonProps: {
            style: { display: 'none' },
          },
        })
      }
      return Promise.reject(res)
    }
    return Promise.resolve(res)
  },
  (err) => {
    if (err?.response?.config?.params?.mute) {
      return Promise.reject(err)
    }
    if (!err.response?.config.customErr && err.message !== 'cancel-request-because-not-login') {
      const resStatus = err?.response?.status
      const errMsg = err?.response?.data?.message || '系统错误'
      if (resStatus === 403) {
        // const desc = '用户无权限'
        // MetisMessage.error({
        //   message: '错误提示',
        //   description: desc,
        // })
      } else if (JSON.stringify(err).includes('timeout of 20000ms exceeded')) {
        MetisMessage.error('请求超时，请重试')
      } else if (JSON.stringify(err).includes('Network Error')) {
        MetisMessage.error('网络错误')
      } else {
        MetisMessage.error(errMsg || '错误提示')
      }
    }
    return Promise.reject(err)
  },
)

const { CancelToken } = axios

export const getAuthorizationHeader = () => ({
  Authorization: `Bearer ${getAccessToken()}`,
})

export function request<T>(req: CostomAxiosRequestConfig): AxiosPromise<T> {
  const source = CancelToken.source()
  return instance.request({
    ...req,
    cancelToken: source.token,
    // @ts-ignore
    cancelTokenSource: source,
  })
}

export default instance
